import { useEffect, useState } from "react";
import withAuthLayout from "../../hoc/withAuthLayout";
import OtpInput from 'react-otp-input';
import { useLocation, useNavigate } from "react-router-dom";
import BackIcon from '../../assets/back.svg';
import AuthContainer from "../../components/ui/AuthContainer";
import { VerifyOTP } from "../../utils/api";
import { message } from "antd";
import { setInLocalStorage } from "../../utils/storageUtil";



const VerifyPassword = () => {

    const { state: id } = useLocation();
    
    const navigate = useNavigate();
    const [otp, setOtp] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const onSubmit = async (e) => {
        e.preventDefault();
        if (otp?.length < 4) {
            setError("OTP is not valid.");
            return;
        }

        const verifyData = {
            userId: id,
            activationCode: otp,
        }

        try {
            setLoading(true);
            const resData = await VerifyOTP(verifyData);
            if (resData?.isSuccess) {
                setInLocalStorage('isOtpVerified', true);
                setLoading(false);
                navigate('/auth/reset-password', { state: resData?.data?.id });
            } else {
                message.destroy();
                message.error(resData?.error);
                setLoading(false);
            }
        } catch (error) {
            console.error('Login error:', error);
            message.error('An error occurred during login. Please try again later.');
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        setError('');
    }, [otp]);

    const inputStyle = {
        width: '50px',
        height: '62px',
        borderRadius: '7px',
        // border: '0px',
        marginRight: '16px',
        border: '1px solid #376197',
        // background: '#BA8A8C',
        color: '#000',
        fontSize: '20px',
        outlineColor: '#fff'
    }

    return (
        <AuthContainer>
            <div className="pb-4 flex gap-x-2 items-center cursor-pointer" onClick={() => navigate('/auth/forgot-password')}>
                <img className="" src={BackIcon} width={15} alt="back-arrow" />
                <span className="2xl:text-lg text-[13px] font-medium text-black-700">Back</span>
            </div>
            <h2 className="font-bold text-base heading">Verify Email</h2>
            <h4 className="2xl:text-base font-semibold text-xs">OTP Verification</h4>
            <p className="text-[12px] 2xl:text-base text-input-placeholder">Enter the OTP sent to your registered email address.</p>
            <form className="flex flex-col opt-inputt" onSubmit={onSubmit}>
                <div className="flex mt-2 w-full items-center">
                    <OtpInput
                        value={otp}
                        onChange={setOtp}
                        inputType="number"
                        inputStyle={inputStyle}
                        numInputs={4}
                        renderSeparator={<span></span>}
                        renderInput={(props) => <input {...props} />}
                    />
                </div>
                <p className="text-[red] text-[12px]">{error}</p>

                {/* <button type="submit" className="sign-in mt-12 bg-primary-700 w-max mx-auto text-white text-[12px] px-12 py-3 rounded-lg">Verify</button> */}
                <button type="submit" className="sign-in mt-6 bg-[#E5B3B2] w-max mx-auto text-white text-[10px] px-12 py-3 rounded-lg flex items-center gap-x-2">
                    <span>Submit</span>
                    {loading && <span className="loader"></span>}
                </button>
            </form>
        </AuthContainer>
    )
}

export default withAuthLayout(VerifyPassword);